import { Quote } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CTASection } from "@/components/CTASection";
import { TESTIMONIALS } from "@/data/content";

export default function Testimonials() {
  return (
    <>
      <Seo
        title="Stories — Brightside Befriending Services, Glasgow"
        siteName="Brightside Befriending Services"
        description="What befriending means to the families we work with across Glasgow — stories of company, confidence and small weekly joys."
      />
      <PageHero
        eyebrow="Stories"
        lines={["The difference a", "Wednesday can make."]}
        text="The small, ordinary moments are the ones families remember. Here's what companionship looks like when it works."
      />

      <section className="px-4 pb-24 sm:px-6 lg:px-8" data-testid="testimonials-grid">
        <div className="mx-auto grid max-w-7xl gap-6 md:grid-cols-2 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={(i % 3) * 0.08} className={i % 3 === 1 ? "lg:translate-y-8" : ""}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="flex h-full flex-col rounded-3xl border border-sand bg-white p-8 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_rgba(28,56,41,0.12)]"
              >
                <Quote className="h-7 w-7 text-terracotta/60" />
                <blockquote className="mt-5 flex-1 font-serif text-lg italic leading-relaxed text-forest">“{t.quote}”</blockquote>
                <figcaption className="mt-6 border-t border-sand pt-4 text-sm">
                  <span className="font-semibold text-forest">{t.name}</span>
                  <span className="block text-xs text-pebble">{t.relation} · {t.area}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-12 text-center text-xs text-pebble/70" data-testid="testimonials-disclaimer">
            These are illustrative stories, shared with warmth, of the experiences Brightside is built to create. Real family testimonials will appear here as families choose to share them.
          </p>
        </Reveal>
      </section>

      <CTASection title="Your family's story starts with a chat" text="Book a free consultation and let's talk about what a brighter week could look like." />
    </>
  );
}
